import {defineRule} from 'vee-validate'
import {required} from '@vee-validate/rules'

// All Rules: https://vee-validate.logaretm.com/v4/guide/global-validators/#available-rules
defineRule('required', required)
